import type { AdminBusinessListItem, AdminMeResponse } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'
import type { AdminUser, BusinessListItem } from '~/shared/types/admin'

export const adminApi = {
  async getCurrentAdmin(): Promise<AdminUser> {
    const res = await api.api.admin.me.$get()
    const body = await unwrap<AdminMeResponse>(res)
    return {
      userId: body.user.id,
      email: body.user.email,
      roles: body.user.roles.join(','),
    }
  },

  async getAllBusinesses(): Promise<BusinessListItem[]> {
    const res = await api.api.admin.businesses.$get()
    const body = await unwrap<AdminBusinessListItem[]>(res)
    return body.map((b) => ({ id: b.id, legalName: b.legalName }))
  },
}
